import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);
  const [pinRequired, setPinRequired] = useState(false);

  useEffect(() => {
    const init = async () => {
      const token = localStorage.getItem("vd_token");
      if (token) {
        try {
          const r = await api.get("/auth/me");
          setUser(r.data);
          setReady(true);
          return;
        } catch {
          localStorage.removeItem("vd_token");
        }
      }
      // Check whether access is protected by a PIN
      try {
        const mode = await api.get("/auth/access-mode");
        if (mode.data.pin_required) {
          setPinRequired(true);
          setUser(false);
          setReady(true);
          return;
        }
      } catch {
        /* ignore, fall through to auto-login */
      }
      // Silent auto-login for the owner (passwordless access)
      try {
        const r = await api.post("/auth/auto-login");
        localStorage.setItem("vd_token", r.data.token);
        setUser(r.data.user);
      } catch {
        setUser(false);
      } finally {
        setReady(true);
      }
    };
    init();
  }, []);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    localStorage.setItem("vd_token", res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const pinLogin = async (pin) => {
    const res = await api.post("/auth/pin-login", { pin });
    localStorage.setItem("vd_token", res.data.token);
    setUser(res.data.user);
    setPinRequired(false);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem("vd_token");
    setUser(false);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, ready, pinRequired, login, pinLogin, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
